__turbopack_context__.v({
  "actions": "style-module-scss-module__JqwHfq__actions",
  "active": "style-module-scss-module__JqwHfq__active",
  "btnAlerts": "style-module-scss-module__JqwHfq__btnAlerts",
  "btnAlertsHighlight": "style-module-scss-module__JqwHfq__btnAlertsHighlight",
  "btnAsk": "style-module-scss-module__JqwHfq__btnAsk",
  "btnAskIcon": "style-module-scss-module__JqwHfq__btnAskIcon",
  "forceBackground": "style-module-scss-module__JqwHfq__forceBackground",
  "hamburger": "style-module-scss-module__JqwHfq__hamburger",
  "header": "style-module-scss-module__JqwHfq__header",
  "inner": "style-module-scss-module__JqwHfq__inner",
  "logo": "style-module-scss-module__JqwHfq__logo",
  "logoSvg": "style-module-scss-module__JqwHfq__logoSvg",
  "mobileAsk": "style-module-scss-module__JqwHfq__mobileAsk",
  "mobileMenu": "style-module-scss-module__JqwHfq__mobileMenu",
  "mobileMenuOpen": "style-module-scss-module__JqwHfq__mobileMenuOpen",
  "mobileNavLink": "style-module-scss-module__JqwHfq__mobileNavLink",
  "mobileNavLinks": "style-module-scss-module__JqwHfq__mobileNavLinks",
  "nav": "style-module-scss-module__JqwHfq__nav",
  "navLink": "style-module-scss-module__JqwHfq__navLink",
  "navLinks": "style-module-scss-module__JqwHfq__navLinks",
  "solidify": "style-module-scss-module__JqwHfq__solidify",
});
